export { default } from "./CategoryNotFound.jsx";
